import React from 'react'
import { Grid, GridItem, Card } from '@deal/components'
import SellableCardCarousel from '#src/components/SellableCardCarousel'
import { SellableCardCarouselExperimentProps } from '../'
import styles from './styles.css'

const SellableCardCarouselWithTitle: React.SFC<SellableCardCarouselExperimentProps> = ({
  title,
  aspectRatio = 'tall',
  className,
  sellables,
  ...rest
}) => {
  return (
    <Grid className={className}>
      <GridItem
        col={2}
        smCol={8}
        mdCol={3}
        xlgCol={aspectRatio === 'wide' ? 3 : 2}
        className={styles.titleContainer}
      >
        <h2 className={styles.title}>{title}</h2>
        <Card accent="black" className={styles.titleCard}>
          {title}
        </Card>
      </GridItem>
      <GridItem col={2} smCol={8} mdCol={9} xlgCol={aspectRatio === 'wide' ? 9 : 10}>
        <SellableCardCarousel sellables={sellables} {...rest} />
      </GridItem>
    </Grid>
  )
}

export default SellableCardCarouselWithTitle
